import i18n from '@/locale/i18n'

import simpel from '@/page/everyDaySpecial/simple.vue'
import index from '@/page/everyDaySpecial/index.vue'
import couponDetail from '@/page/everyDaySpecial/couponDetail.vue'
import couponDestruction from '@/page/everyDaySpecial/couponDestruction.vue'
import SystemMaintenance from '@/page/SystemMaintenance.vue'
export default [
    {
        // redirect: '/everyDaySpecial/index',
        path: '/everyDaySpecial/simple',
        component: simpel,
        meta: { title: i18n.t('everyDaySpecial.title'), keepAlive: true }
    },
    {
        path: '/everyDaySpecial/index',
        component: index,
        meta: { title: i18n.t('everyDaySpecial.title') }
    },
    {
        path: '/everyDaySpecial/couponDetail',
        component: couponDetail,
        meta: { title: '详情' }
    },
    {
        path: '/everyDaySpecial/couponDestruction',
        component: couponDestruction,
        meta: { title: '核销' }
    },
    {
        path: '/SystemMaintenance',
        component: SystemMaintenance,
        meta: { title: i18n.t('SystemMaintenance.title') }
    }
]



// WEBPACK FOOTER //
// ./src/router/everyDaySpecial/index.js